export enum ColumnType {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  Date = 'date',
  Template = 'template'
}

export enum StringOperator {
  Equals = 'equals',
  StartsWith = 'startsWith',
  EndsWith = 'endsWith',
  Contains = 'contains'
}

export enum NumberOperator {
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  LessThanOrEqual = 'lessThanOrEqual'
}

export enum BooleanOperator {
  Equals = 'equals',
  NotEquals = 'notEquals',
  IsTrue = 'isTrue',
  IsFalse = 'isFalse'
}

export enum DateOperator {
  Equals = 'equals',
  Before = 'before',
  After = 'after',
  Between = 'between'
}

export interface FilterCondition {
  columnName: string;
  columnType: ColumnType;
  operator: StringOperator | NumberOperator | BooleanOperator | DateOperator;
  value: string | number | boolean | Date;
  endValue?: Date; // for date range (between operator)
}

export interface FilterConfig {
  conditions: FilterCondition[];
  operator: 'AND' | 'OR';
}
